module.exports = __webpack_public_path__ + "img/emoji_88.cf6ccc66.png";